var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zj-iframe-container"},[_c('iframe',{staticClass:"zj-iframe",attrs:{"src":_vm.url,"scrolling":"auto","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }